import { render, staticRenderFns } from "./distribution-channel.vue?vue&type=template&id=a854bd00&scoped=true&"
import script from "./distribution-channel.vue?vue&type=script&lang=js&"
export * from "./distribution-channel.vue?vue&type=script&lang=js&"
import style0 from "./distribution-channel.vue?vue&type=style&index=0&id=a854bd00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a854bd00",
  null
  
)

export default component.exports